// Static data for the Navbar component

export const NAV_LINKS = [
  { label: 'About Us', path: '/about' },
  {
    label: 'Destinations',
    path: '/destinations',
    dropdown: [
      { label: 'Hanoi & the North', path: '/destinations/hanoi' },
      { label: 'Ha Long Bay', path: '/destinations/ha-long-bay' },
      { label: 'Da Nang & Hoi An', path: '/destinations/da-nang-hoi-an' },
      { label: 'Ho Chi Minh City', path: '/destinations/ho-chi-minh-city' },
      { label: 'Phu Quoc Island', path: '/destinations/phu-quoc' },
      { label: 'Mekong Delta', path: '/destinations/mekong-delta' },
    ],
  },
  {
    label: 'Services',
    path: '/services',
    dropdown: [
      { label: 'Custom Itineraries', path: '/services/custom-itineraries' },
      { label: 'Group & MICE Travel', path: '/services/mice' },
      { label: 'Luxury Stays', path: '/services/luxury-stays' },
      { label: 'Visa & Documentation', path: '/services/visa' },
      { label: 'Airport & Ground Transfers', path: '/services/transfers' },
    ],
  },
  { label: 'Partner With Us', path: '/partner-with-us' },
  { label: 'News', path: '/news' },
  { label: 'Contact Us', path: '/contact' },
];

export const BRAND = {
  name: 'OrbisDMC',
  tagline: 'Vietnam, Curated',
};
